/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/jsx-no-bind */
import { Text, Center, useBreakpointValue } from '@chakra-ui/react';
import { useCallback, useEffect, useMemo, useState, useContext } from 'react';

import DayPicker, { DayModifiers } from 'react-day-picker';
import { Calendar } from './styles';
import 'react-day-picker/lib/style.css';
import { api } from '../../../../services/api';
import PopoverComp from '../../Popover';
import { SetToggleThemeContext } from '../../../../contexts/SetToggleThemeContext';
import {
  filterAppointmentsByVehicle,
  getAppointmentsForDay,
  hasAvailableSlotInDay,
} from '../../../../utils/appointmentAvailability';

// interface Appointments {
//   id: string;
//   date: string;
//   hourFormatted: string;
//   user: {
//     name: string;
//     avatar_url: string;
//   };
// }

interface Appointments {
  id: string;
  vehicle_id: string;
  date: string;
  start_date: string;
  end_date: string;
  status: string;
  route: string;
  vehicle: {
    name: string;
  };
  conductor: {
    name: string;
  };
  leader: {
    name: string;
  };
}

interface IAppointmentsResponse {
  appointment: Appointments[];
}

interface ICalendarProps {
  newAppointment: string;
  vehicleSelected: any;
  handleDateSelected: (day: Omit<string, ''>) => void;
}

export function CalendarPiker({
  vehicleSelected,
  handleDateSelected,
  newAppointment,
}: ICalendarProps) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [newDeleted, setNewDeleted] = useState();

  const [appointments, setAppointments] = useState<Appointments[]>([]);
  const [appointmentsLoadStatus, setAppointmentsLoadStatus] = useState<
    'idle' | 'loading' | 'ready' | 'error'
  >('idle');
  const { toggleTheme } = useContext(SetToggleThemeContext);
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  useEffect(() => {
    if (vehicleSelected === 'Nenhum veiculo selecionado') {
      setAppointments([]);
      setAppointmentsLoadStatus('idle');
      return undefined;
    }

    let componentIsMounted = true;
    setAppointments([]);
    setAppointmentsLoadStatus('loading');

    api
      .get<IAppointmentsResponse>('/appointments/filter', {
        params: {
          vehicle_id: vehicleSelected,
          take: 9999,
          page: 1,
        },
      })
      .then(response => {
        if (componentIsMounted) {
          const data = response.data?.appointment;
          setAppointments(
            Array.isArray(data)
              ? filterAppointmentsByVehicle(data, vehicleSelected)
              : [],
          );
          setAppointmentsLoadStatus('ready');
        }
      })
      .catch(() => {
        if (componentIsMounted) {
          setAppointments([]);
          setAppointmentsLoadStatus('error');
        }
      });

    return () => {
      componentIsMounted = false;
    };
  }, [newDeleted, newAppointment, vehicleSelected]);

  const handleDateChange = useCallback(
    (day: Date, modifiers: DayModifiers) => {
      if (modifiers.available && !modifiers.disabled) {
        setSelectedDate(day);

        handleDateSelected(String(day));
      }
    },
    [handleDateSelected],
  );

  const handleMonthChange = useCallback((month: Date) => {
    setCurrentMonth(month);
  }, []);

  const disabledDays = useMemo(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const lastDay = new Date(year, month + 1, 0).getDate();

    const monthDays = Array.from({ length: lastDay }, (_, index) => {
      return new Date(year, month, index + 1);
    });

    if (appointmentsLoadStatus !== 'ready') return monthDays;

    return monthDays.filter(day => !hasAvailableSlotInDay(appointments, day));
  }, [appointments, appointmentsLoadStatus, currentMonth]);

  const handleletedAppointments = useCallback(event => {
    setNewDeleted(event);
  }, []);

  function renderDay(day: Date, modifiers: DayModifiers) {
    const date = day.getDate();
    const appointmentsFiltred = getAppointmentsForDay(appointments, day);
    return (
      <div className="card">
        <span>{date}</span>
        {isWideVersion && (
          <div>
            {appointmentsFiltred.map(e => {
              return (
                <PopoverComp
                  key={e.id}
                  handleletedAppointments={handleletedAppointments}
                  hassPass={!modifiers.disabled ?? true}
                  conductor={e.conductor.name}
                  appointments={e}
                  theme={toggleTheme}
                />
              );
            })}
          </div>
        )}
        {/* {birthdays.day === date
          ? birthdays.map((name: void) => (
              <div>
                <Tooltip label="agendamento">🎁 {name}</Tooltip>
              </div>
            ))
          : ''} */}
      </div>
    );
  }
  return (
    <Calendar theme={toggleTheme}>
      {vehicleSelected === 'Nenhum veiculo selecionado' ? (
        <Center>
          <Text>{vehicleSelected}</Text>
        </Center>
      ) : (
        <>
          {appointmentsLoadStatus === 'error' && (
            <Text color="orange.400" mb="4" textAlign="center">
              Não foi possível carregar a agenda deste veículo. Tente novamente.
            </Text>
          )}
          {/* @ts-ignore */}
          <DayPicker
            weekdaysShort={
              isWideVersion
                ? [
                    'Domingo',
                    'Segunda',
                    'Terça',
                    'Quarta',
                    'Quinta',
                    'Sexta',
                    'Sábado',
                  ]
                : ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
            }
            fromMonth={new Date()}
            onMonthChange={handleMonthChange}
            selectedDays={selectedDate}
            disabledDays={[...disabledDays]}
            // disabledDays={[{ daysOfWeek: [0, 6] }, ...disabledDays]}
            renderDay={renderDay}
            modifiers={{
              available: { daysOfWeek: [0, 1, 2, 3, 4, 5, 6] },
            }}
            onDayClick={handleDateChange}
            months={[
              'Janeiro',
              'Fevereiro',
              'Março',
              'Abril',
              'Maio',
              'Junho',
              'Julho',
              'Agosto',
              'Setembro',
              'Outubro',
              'Novembro',
              'Dezembro',
            ]}
          />
        </>
      )}
    </Calendar>
  );
}
